import React from 'react'
import DetailedOrderReportContainer from './DetailedOrderReportContainer'

export default function DetailedOrderReportScreen() {
    return <DetailedOrderReportContainer />
}
